var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders"},[_c('embed',{staticClass:"statusOrders",staticStyle:{"width":"100vw","height":"calc(100vh - 65px)"},attrs:{"src":"https://cicopal-aprova-historico.vercel.app/"}})])
}]

export { render, staticRenderFns }